import axios from "axios";
import qs from "qs";
import decorateLoading from "./decorateLoading.js";
import success from "./success.js";
import {
  text
} from "cignacmb-vue-components-mobile/src/popup-instances/toast.js";

const handler = function (data) { return Promise.resolve(data) }

export default function ({ decorateConfig }) {
  typeof decorateConfig === "function" || (decorateConfig = handler);
  /*
  config对象除了多一个isNeedFullScreenLoading属性, 其他都与和axios的config一致
  isNeedFullScreenLoading属性标识这个请求发起的时候是否需要显示全局的loading
  */
  return function (config) {
    config.method || (config.method = "GET");
    typeof config.timeout === "number" || (config.timeout = 15000);

    if (typeof config.isNeedFullScreenLoading !== "boolean") {
      config.isNeedFullScreenLoading =  config.url != '/activityLikes/saveOrCancelLikes';
      // 如果他的url=/activityLikes/saveOrCancelLikes 就不让他有延迟图标出现
    }

    if (config.method === "GET" && !config.params && config.data) {
      config.params = config.data;
    }

    config.headers || (config.headers = {});

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=utf-8";
    }

    if (config.headers["Content-Type"].indexOf("application/x-www-form-urlencoded") > -1
      && config.data !== null
      && typeof config.data === "object") {
      config.data = qs.stringify(config.data);
    }

    const send = function () {
      return decorateConfig(config)
        .then(function (config) {       
          return axios(config);        
        })
        .then(function (response) {
          return response.data;
        }).then(success, function (error) {
          // 处理断网、超时
          let message = error.message;

          if (error.code === "ECONNABORTED") {
            message = "请求超时, 请稍后再试!";
          } else if (error.request && error.request.status == 0) {
            message = "网络异常!";
          } else if (message.indexOf("Request failed with status code") > -1) {
            message = "请求发生错误, 请稍后重试!";
          }

          text.open({ message });

          error.message = message;

          return Promise.reject(error);
        });
    };

    if (config.isNeedFullScreenLoading) {
      return decorateLoading(send());
    }

    return send();
  }
}